import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight, Phone } from 'lucide-react'
import { buttonStyles } from '@/lib/button-styles'
import { Bubble } from '@/components/generals/bubble'
import { Container } from '@/components/generals/container'
import { business } from '@/constants/business'

export const CtaSection: FC = (): ReactNode => {
    return (
        <section aria-labelledby='cta-title' className='bg-background pb-20 sm:pb-28'>
            <Container>
                <div className='relative overflow-hidden rounded-[2rem] bg-linear-to-br from-aqua via-aqua to-aqua-strong px-6 py-16 text-center sm:px-12 sm:py-20'>
                    <Bubble className='left-[6%] top-8 size-16' />
                    <Bubble className='bottom-6 left-[18%] size-9 [animation-delay:-3s]' />
                    <Bubble className='right-[8%] top-12 size-24 [animation-delay:-1.5s]' />
                    <Bubble className='bottom-10 right-[24%] hidden size-12 [animation-delay:-5s] sm:block' />

                    <h2 id='cta-title' className='relative mx-auto max-w-3xl font-heading text-[2.6rem] font-bold uppercase leading-[0.92] tracking-tight text-ink sm:text-6xl'>
                        Ready for that just-washed feeling?
                    </h2>

                    <p className='relative mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink/80'>
                        Book online in under a minute, or drive in today. We'll have the foam ready.
                    </p>

                    <div className='relative mt-9 flex flex-wrap justify-center gap-3'>
                        <Link href='/book' className={buttonStyles({ variant: 'dark', size: 'lg' })}>
                            Book a wash
                            <ArrowRight className='size-5' />
                        </Link>

                        <a
                            href={business.phone.href}
                            className={buttonStyles({ variant: 'outline', size: 'lg', className: 'border-ink/15 bg-white/50 hover:border-ink/30 hover:bg-white/80' })}
                        >
                            <Phone className='size-5' />
                            {business.phone.display}
                        </a>
                    </div>
                </div>
            </Container>
        </section>
    )
}
